import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavHeaderSearchContainerTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavHeaderSearchContainer--wc.css')}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplateNavHeaderSearchContainerStyles = () => createNavHeaderSearchContainerTemplate()
export { getTemplateNavHeaderSearchContainerStyles }
